// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3FyCj","vLegacy":"SelectSecondary_vLegacy__2ti5Q","error":"SelectSecondary_error__2mTwO","disabled":"SelectSecondary_disabled__2IP3j"};